export default {"src":"/_next/static/media/chevron-down-solid.a6ecfb0c.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};